<script setup lang="ts">
</script>

<template>
  <div class="flex flex-col items-center justify-center py-16 px-4 text-center">
    <div class="mb-6">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1"
        stroke="currentColor"
        class="w-16 h-16 text-gray-300"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
        />
      </svg>
    </div>
    <h3 class="text-xl font-medium text-gray-900 mb-2">
      Keine Diamanten gefunden
    </h3>
    <p class="text-gray-500 max-w-sm">
      Leider konnten wir keine Diamanten finden, die Ihren Suchkriterien entsprechen. Bitte versuchen Sie, Ihre Filter anzupassen.
    </p>
  </div>
</template>

<style scoped>
</style>